import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import { Link } from 'react-router-dom';

const PrivacyPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <main className="pt-32 pb-20">
        <div className="max-w-4xl mx-auto px-6">
          {/* Breadcrumb */}
          <nav className="mb-8">
            <ol className="flex items-center gap-2 text-sm text-text-secondary">
              <li>
                <Link to="/" className="hover:text-text-primary transition-colors cursor-pointer">
                  ホーム
                </Link>
              </li>
              <li>
                <i className="ri-arrow-right-s-line"></i>
              </li>
              <li className="text-text-primary font-medium">プライバシーポリシー</li>
            </ol>
          </nav>

          {/* Page Title */}
          <h1 className="text-5xl font-black font-maru text-text-primary mb-4">
            プライバシーポリシー
          </h1>
          <p className="text-text-secondary text-sm mb-12">
            最終更新日: 2025年12月15日
          </p>

          {/* Content */}
          <div className="space-y-12">
            <section>
              <p className="text-text-secondary leading-relaxed">
                赤ちゃんダイアリー(以下「当運営」といいます)は、本アプリ上で提供するサービス(以下「本サービス」といいます)における、ユーザーの個人情報の取扱いについて、以下のとおりプライバシーポリシー(以下「本ポリシー」といいます)を定めます。
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold font-maru text-text-primary mb-4">
                第1条(個人情報)
              </h2>
              <p className="text-text-secondary leading-relaxed">
                「個人情報」とは、個人情報保護法にいう「個人情報」を指すものとし、生存する個人に関する情報であって、当該情報に含まれる氏名、生年月日、住所、電話番号、連絡先その他の記述等により特定の個人を識別できる情報及び容貌、指紋、声紋にかかるデータ、及び健康保険証の保険者番号などの当該情報単体から特定の個人を識別できる情報(個人識別情報)を指します。
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold font-maru text-text-primary mb-4">
                第2条(個人情報の収集方法)
              </h2>
              <p className="text-text-secondary leading-relaxed mb-4">
                当運営は、ユーザーが利用する際に、以下の個人情報をお尋ねすることがあります。
              </p>
              <ul className="space-y-2 ml-6">
                <li className="flex items-start gap-3">
                  <span className="w-2 h-2 bg-primary rounded-full mt-2 flex-shrink-0"></span>
                  <span className="text-text-secondary leading-relaxed">
                    赤ちゃんの名前、生年月日
                  </span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="w-2 h-2 bg-primary rounded-full mt-2 flex-shrink-0"></span>
                  <span className="text-text-secondary leading-relaxed">
                    日記データ
                  </span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="w-2 h-2 bg-primary rounded-full mt-2 flex-shrink-0"></span>
                  <span className="text-text-secondary leading-relaxed">
                    写真データ
                  </span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="w-2 h-2 bg-primary rounded-full mt-2 flex-shrink-0"></span>
                  <span className="text-text-secondary leading-relaxed">
                    成長記録データ(身長、体重等)
                  </span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="w-2 h-2 bg-primary rounded-full mt-2 flex-shrink-0"></span>
                  <span className="text-text-secondary leading-relaxed">
                    メールアドレス(お問い合わせ対応のため)
                  </span>
                </li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-bold font-maru text-text-primary mb-4">
                第3条(個人情報を収集・利用する目的)
              </h2>
              <p className="text-text-secondary leading-relaxed mb-4">
                当運営が個人情報を収集・利用する目的は、以下のとおりです。
              </p>
              <ul className="space-y-2 ml-6">
                <li className="flex items-start gap-3">
                  <span className="w-2 h-2 bg-primary rounded-full mt-2 flex-shrink-0"></span>
                  <span className="text-text-secondary leading-relaxed">
                    本サービスの提供・運営のため
                  </span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="w-2 h-2 bg-primary rounded-full mt-2 flex-shrink-0"></span>
                  <span className="text-text-secondary leading-relaxed">
                    ユーザーからのお問い合わせに回答するため
                  </span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="w-2 h-2 bg-primary rounded-full mt-2 flex-shrink-0"></span>
                  <span className="text-text-secondary leading-relaxed">
                    利用規約に違反したユーザーや、不正・不当な目的でサービスを利用しようとするユーザーの特定をし、ご利用をお断りするため
                  </span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="w-2 h-2 bg-primary rounded-full mt-2 flex-shrink-0"></span>
                  <span className="text-text-secondary leading-relaxed">
                    ユーザーにご自身の登録情報の閲覧や変更、削除、ご利用状況の閲覧を行っていただくため
                  </span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="w-2 h-2 bg-primary rounded-full mt-2 flex-shrink-0"></span>
                  <span className="text-text-secondary leading-relaxed">
                    上記の利用目的に付随する目的
                  </span>
                </li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-bold font-maru text-text-primary mb-4">
                第4条(利用目的の変更)
              </h2>
              <p className="text-text-secondary leading-relaxed mb-4">
                当運営は、利用目的が変更前と関連性を有すると合理的に認められる場合に限り、個人情報の利用目的を変更するものとします。
              </p>
              <p className="text-text-secondary leading-relaxed">
                利用目的の変更を行った場合には、変更後の目的について、当運営所定の方法により、ユーザーに通知し、または本ウェブサイト上に公表するものとします。
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold font-maru text-text-primary mb-4">
                第5条(第三者サービスの利用)
              </h2>
              <p className="text-text-secondary leading-relaxed mb-4">
                本サービスでは、サービスの品質向上、広告配信、およびユーザー体験の最適化のために、以下の第三者サービスを利用しています。これらのサービスは独自のプライバシーポリシーに基づいて情報を収集・利用する場合があります。
              </p>
              
              <div className="space-y-6">
                <div className="bg-background p-6 rounded-xl">
                  <h3 className="text-lg font-bold font-maru text-text-primary mb-3">
                    Readdy
                  </h3>
                  <p className="text-text-secondary leading-relaxed mb-3">
                    本サービスのウェブサイトは、Readdyを使用して構築・運営されています。Readdyは、ウェブサイトのホスティング、パフォーマンス最適化、およびサイト運営に必要な技術的サポートを提供しています。
                  </p>
                  <a
                    href="https://readdy.ai/privacy-policy"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-cta text-sm font-medium hover:underline cursor-pointer whitespace-nowrap"
                  >
                    Readdyプライバシーポリシー
                    <i className="ri-external-link-line ml-1"></i>
                  </a>
                </div>

                <div className="bg-background p-6 rounded-xl">
                  <h3 className="text-lg font-bold font-maru text-text-primary mb-3">
                    Google AdMob
                  </h3>
                  <p className="text-text-secondary leading-relaxed mb-3">
                    本サービスでは、広告配信のためにGoogle AdMobを使用しています。AdMobは、広告識別子やIPアドレス、デバイス情報などを収集し、パーソナライズされた広告を表示する場合があります。
                  </p>
                  <a
                    href="https://policies.google.com/privacy"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-cta text-sm font-medium hover:underline cursor-pointer whitespace-nowrap"
                  >
                    Googleプライバシーポリシー
                    <i className="ri-external-link-line ml-1"></i>
                  </a>
                </div>

                <div className="bg-background p-6 rounded-xl">
                  <h3 className="text-lg font-bold font-maru text-text-primary mb-3">
                    Firebase Analytics
                  </h3>
                  <p className="text-text-secondary leading-relaxed mb-3">
                    本サービスでは、アプリの利用状況の分析とサービス改善のためにFirebase Analyticsを使用しています。Firebase Analyticsは、アプリの使用状況、デバイス情報、アプリ内での行動データなどを収集します。
                  </p>
                  <a
                    href="https://firebase.google.com/support/privacy"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-cta text-sm font-medium hover:underline cursor-pointer whitespace-nowrap"
                  >
                    Firebaseプライバシーとセキュリティ
                    <i className="ri-external-link-line ml-1"></i>
                  </a>
                </div>

                <div className="bg-background p-6 rounded-xl">
                  <h3 className="text-lg font-bold font-maru text-text-primary mb-3">
                    Google Fonts
                  </h3>
                  <p className="text-text-secondary leading-relaxed mb-3">
                    本サービスでは、フォント表示のためにGoogle Fontsを使用しています。Google Fontsの利用時に、お使いのブラウザがGoogleのサーバーに接続し、IPアドレスなどの情報が送信される場合があります。
                  </p>
                  <a
                    href="https://policies.google.com/privacy"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-cta text-sm font-medium hover:underline cursor-pointer whitespace-nowrap"
                  >
                    Googleプライバシーポリシー
                    <i className="ri-external-link-line ml-1"></i>
                  </a>
                </div>
              </div>

              <p className="text-text-secondary leading-relaxed mt-6">
                これらの第三者サービスによる情報の収集・利用については、各サービスのプライバシーポリシーをご確認ください。
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold font-maru text-text-primary mb-4">
                第6条(個人情報の第三者提供)
              </h2>
              <p className="text-text-secondary leading-relaxed mb-4">
                当運営は、本サービスの提供にあたり、前条に記載の第三者サービス(Readdy、Google AdMob、Firebase Analytics、Google Fonts)を利用しており、これらのサービス提供者に対して、サービスの運営上必要な範囲で情報が提供されます。
              </p>
              <p className="text-text-secondary leading-relaxed mb-4">
                また、当運営は、上記以外で次に掲げる場合を除いて、あらかじめユーザーの同意を得ることなく、第三者に個人情報を提供することはありません。ただし、以下の場合を除きます。
              </p>
              <ul className="space-y-2 ml-6">
                <li className="flex items-start gap-3">
                  <span className="w-2 h-2 bg-primary rounded-full mt-2 flex-shrink-0"></span>
                  <span className="text-text-secondary leading-relaxed">
                    法的要請がある場合
                  </span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="w-2 h-2 bg-primary rounded-full mt-2 flex-shrink-0"></span>
                  <span className="text-text-secondary leading-relaxed">
                    ユーザーの同意がある場合
                  </span>
                </li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-bold font-maru text-text-primary mb-4">
                第7条(個人情報の開示)
              </h2>
              <p className="text-text-secondary leading-relaxed">
                当運営は、本人から個人情報の開示を求められたときは、本人に対し、遅滞なくこれを開示します。ただし、開示することにより次のいずれかに該当する場合は、その全部または一部を開示しないこともあり、開示しない決定をした場合には、その旨を遅滞なく通知します。
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold font-maru text-text-primary mb-4">
                第8条(個人情報の訂正および削除)
              </h2>
              <p className="text-text-secondary leading-relaxed mb-4">
                ユーザーは、当運営の保有する自己の個人情報が誤った情報である場合には、当運営が定める手続きにより、当運営に対して個人情報の訂正、追加または削除(以下「訂正等」といいます)を請求することができます。
              </p>
              <p className="text-text-secondary leading-relaxed">
                当運営は、ユーザーから前項の請求を受けてその請求に応じる必要があると判断した場合には、遅滞なく、当該個人情報の訂正等を行うものとします。
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold font-maru text-text-primary mb-4">
                第9条(個人情報の利用停止等)
              </h2>
              <p className="text-text-secondary leading-relaxed">
                当運営は、本人から、個人情報が、利用目的の範囲を超えて取り扱われているという理由、または不正の手段により取得されたものであるという理由により、その利用の停止または消去(以下「利用停止等」といいます)を求められた場合には、遅滞なく必要な調査を行います。
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold font-maru text-text-primary mb-4">
                第10条(プライバシーポリシーの変更)
              </h2>
              <p className="text-text-secondary leading-relaxed">
                本ポリシーの内容は、法令その他本ポリシーに別段の定めのある事項を除いて、ユーザーに通知することなく、変更することができるものとします。当運営が別途定める場合を除いて、変更後のプライバシーポリシーは、本ウェブサイトに掲載したときから効力を生じるものとします。
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold font-maru text-text-primary mb-4">
                第11条(お問い合わせ窓口)
              </h2>
              <p className="text-text-secondary leading-relaxed mb-4">
                本ポリシーに関するお問い合わせは、下記の窓口までお願いいたします。
              </p>
              <div className="bg-background p-6 rounded-xl">
                <p className="text-text-secondary leading-relaxed">
                  <Link
                    to="/contact"
                    className="text-cta font-bold hover:underline cursor-pointer"
                  >
                    お問い合わせフォーム
                  </Link>
                  よりご連絡ください
                </p>
              </div>
            </section>

            <section className="pt-8 border-t border-text-secondary/20">
              <p className="text-text-secondary text-sm text-center">
                以上
              </p>
            </section>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default PrivacyPage;